import React, { useState, useEffect } from "react";
import "../styles/homepage.css";
import logo from "../assets/fintorro-logo.png"; // Adjust if needed

const Header = () => {
  const [theme, setTheme] = useState("light");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    document.documentElement.setAttribute("data-theme", savedTheme);
    setTheme(savedTheme);
  }, []);

  const toggleTheme = () => {
    const nextTheme = theme === "dark" ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", nextTheme);
    localStorage.setItem("theme", nextTheme);
    setTheme(nextTheme);
  };

  return (
    <header className="sticky-header">
      <div className="container header-container" style={{ padding: '0 1rem' }}>
  <div className="logo-wrapper">
    <img src={logo} alt="Fintorro Logo" className="logo-image" />
  </div>


        {/* <div
          className="hamburger"
          onClick={() => setIsOpen(prev => !prev)}
          aria-label="Toggle navigation"
        >
          <div className={`bar ${isOpen ? "rotate-top" : ""}`} />
          <div className={`bar ${isOpen ? "hide-middle" : ""}`} />
          <div className={`bar ${isOpen ? "rotate-bottom" : ""}`} />
        </div> */}

        {/* <nav className={`nav-links ${isOpen ? "open" : ""}`} role="navigation">
          <ul>
            <li><a href="/" onClick={() => setIsOpen(false)}>Learn with AI</a></li>
            <li><a href="/agents" onClick={() => setIsOpen(false)}>AI Agents</a></li>
            <li>
              <a
                href="https://www.fintorro.com/trading/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsOpen(false)}
              >
                Magazine
              </a>
            </li>
            <li><a href="/" onClick={() => setIsOpen(false)}>Newsletter</a></li>
            <li className="mobile-only">
              <a href="/" className="login-link" onClick={() => setIsOpen(false)}>Login</a>
            </li>
          </ul>
        </nav> */}

        {/* <div className="header-buttons desktop-only">
          <a href="/" className="login-button">Login</a>
          <a href="/" className="cta-button hide-on-mobile">Get Started Free</a>
        </div> */}
      </div>
    </header>
  );
};

export default Header;
